import { ChangeDetectorRef, Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { ExportAsConfig, ExportAsService, SupportedExtensions } from 'ngx-export-as';
import { ApiHandlerService } from 'projects/b2c/src/app/core/api-handlers';
import { SwalService } from 'projects/b2c/src/app/core/services/swal.service';
import { UtilityService } from 'projects/b2c/src/app/core/services/utility.service';
import { SubSink } from 'subsink';
import { environment } from '../../../../../environments/environment';
import { FlightService } from '../../flight.service';

const b2b_url = `${environment.b2b_url}/b2b`

@Component({
    selector: 'app-booking-confirm',
    templateUrl: './booking-confirm.component.html',
    styleUrls: ['./booking-confirm.component.scss']
})
export class BookingConfirmComponent implements OnInit {
    @ViewChild('print_voucher', { static: false }) print_voucher: ElementRef;
    srcUrl: string = "";
    public browserRefresh: boolean;
    currentUser: any;
    todayDate = new Date();
    confirmedData: any;
    contact: any;
    airline_logo: string = '';
    private subSunk = new SubSink();
    isChild = false;
    showConfirmTicket: boolean = true;
    appReference: string;
    ReservationResultIndex: string;
    ticketServerData: any;
    journeyListData: any;
    showConfirmButtons: boolean = true;
    showPaymentDetails: boolean;
    paymentForm: FormGroup;
    submitted: boolean;
    paymentData: any;

    config: ExportAsConfig = {
        type: 'pdf',
        elementIdOrContent: 'print_voucher',
        options: {
            jsPDF: {
                orientation: 'portrait'
            },
            pdfCallbackFn: this.pdfCallbackFn // to add header and footer
        }
    };

    constructor(
        private flightService: FlightService,
        private router: Router,
        private exportAsService: ExportAsService,
        private swalService: SwalService,
        private util: UtilityService,
        private apiHandlerService: ApiHandlerService,
        private activatedRoute: ActivatedRoute,
        private cdr: ChangeDetectorRef,
        private fb: FormBuilder,
    ) { }

    ngOnInit() {
        this.activatedRoute.queryParams.subscribe(params => {
            if (params && params.AppReference)
            this.appReference = (params.AppReference).replace("/", "");
        })
        if (this.appReference && this.appReference != "") {
            let req = { 'AppReference': this.appReference }
            this.subSunk.sink = this.apiHandlerService.apiHandler('flightVoucher', 'post', '', '', req).subscribe(res => {
                if (res) {
                    res.data[0]['FlightItineraries'].forEach((element, i) => {
                        if(element.attributes != "") {
                            let attributes = element.attributes.replace(/\"/gi, "\"");
                            res.data[0]['FlightItineraries'][i]['attributes'] = JSON.parse(attributes);
                        }
                    });
                    this.confirmedData = res.data[0];
                    this.cdr.detectChanges();
                    if (this.confirmedData.Passengers[0].ticket_no) {
                        this.showConfirmTicket = false;
                    }
                    this.airline_logo = this.flightService.airline_logo;
                    this.currentUser = this.util.readStorage('b2cUser', sessionStorage);
                    res.data = this.formatFinalBookingResponse(res.data[0]);//Formating for booking fare summary
                    this.flightService.FinalBookingResponse.next(res.data);
                }
            });
        } else {
            this.airline_logo = this.flightService.airline_logo;
        }
    }

    formatFinalBookingResponse(flightData: any) {
        let itineraries = [];
        flightData.FlightItineraries.forEach(element => {
            let ele = {
                Origin: {
                    "AirportCode": element.from_airport_code,
                    "CityName": "",
                    "AirportName": element.from_airport_name,
                    "DateTime": element.departure_datetime,
                    "FDTV": "",
                    "Terminal": ""
                },
                Destination: {
                    "AirportCode": element.to_airport_code,
                    "CityName": "",
                    "AirportName": element.to_airport_name,
                    "DateTime": element.arrival_datetime,
                    "FATV": "",
                    "Terminal": ""
                },
                "AirlinePNR": element.airline_pnr,
                "OperatorCode": element.airline_code,
                "DisplayOperatorCode": element.airline_code,
                "OperatorName": element.airline_name,
                "FlightNumber": element.flight_no,
                "CabinClass": flightData.CabinClass,
                "booking_source": flightData.ApiCode,
                "Attr": ""
            }
            itineraries.push(ele);
        });
        return {
            FlightDetails: {
                Details: [
                    itineraries
                ]
            },
            Price: flightData.TotalFarePriceBreakUp
        }
    }

    onPageLoad() {
        this.currentUser = this.util.readStorage('b2cUser', sessionStorage);
        this.subSunk.sink = this.apiHandlerService.apiHandler('countryList', 'post', '', '').subscribe(res => {
            let Countries = res.data.popular_countries.concat(res.data.countries);
            let country = Countries.find(list => list.id === this.currentUser.country);
            this.currentUser.country = country.name;
        });
        this.airline_logo = this.flightService.airline_logo;
        this.flightService.FinalBookingResponse.subscribe(res => {
            if (typeof res == 'object' && res.hasOwnProperty('BookingId')) {
                this.confirmedData = res;
                this.util.writeStorage("ticketCache", res, sessionStorage)
                this.isChild = Boolean(res.PassengerDetails.filter(t => t.PassengerType == 'Child').length);
                this.contact = res.PassengerContactDetails;
            } else {
                this.router.navigate(['/']);
            }
        });
    }

    passengerType(code: string): string {
        let result = 'Infant';
        switch (code) {
            case 'ADT':
                result = 'Adult';
                break;

            case 'CHD':
                result = 'Child';
                break;

            default:
                break;
        }
        return result;
    }

    getBaggage(val) {
        if (val) {
            let bg = val.split(" ");
            if (bg.length > 1 && bg[1] != "undefined" && parseInt(bg[0]) > 0)
                return bg[0] + ' ' +
                    ((bg[1] == 'Kilograms' || bg[1] == 'Kg' || bg[1] == 'KGS') ? 'KG' : bg[1]);
            else
                return bg[0] + ' ' + 'KG';
        } else if (val === '') {
            return '0 KG';
        }
    }

    duration(origin, destination) {
        const startDate = new Date(origin);
        // Do your operations
        const endDate = new Date(destination);
        const seconds = (endDate.getTime() - startDate.getTime()) / 1000;
        const minutes = Math.floor(seconds / 60);
        const hours = Math.floor(minutes / 60);

        return hours + ' hr ' + (minutes - (hours * 60)) + ' min';

    }

    getFormtedStatus(status: string) {
        if (status != null) {
            let tmpStatus = status.split('_');
            return `${tmpStatus[0] + ' ' + tmpStatus[1]}`;
        }
    }

    download1(type: SupportedExtensions, orientation?: string) {
        this.config.type = type;
        if (orientation) {
            this.config.options.jsPDF.orientation = orientation;
        }
        const ts = new Date().toDateString();
        this.exportAsService.save(this.config, `${ts}`).subscribe((_) => {
            // save started
            this.swalService.alert.success();
        }, () => {
            this.swalService.alert.oops();

        });
    }
    
    downloadA4(type: SupportedExtensions, orientation?: string): void {
        document.getElementById('download').style.display = "none";
        document.getElementById('ticket').style.display = "none";
        window['html2canvas'] = html2canvas;
        const date = new Date().toDateString();
        const doc = new jsPDF({
            orientation: 'p',
            unit: 'pt',
            format: 'a4',
        });
        const content = this.print_voucher.nativeElement;
        doc.html(content, {
            html2canvas: {
                allowTaint: true,
                useCORS: true,
                scale: 600 / content.scrollWidth
            },
            callback: async (doc) => {
                doc.save(`${this.confirmedData['AppReference']}.pdf`);
                this.swalService.alert.success();
                document.getElementById('download').style.display = "inline-block";
                document.getElementById('ticket').style.display = "inline-block";
            }
        });

    }

    pdfCallbackFn(pdf: any) {
        // example to add page number as footer to every page of pdf
        const noOfPages = pdf.internal.getNumberOfPages();
        for (let i = 1; i <= noOfPages; i++) {
            pdf.setPage(i);
            pdf.text('Page ' + i + ' of ' + noOfPages, pdf.internal.pageSize.getWidth() - 40, pdf.internal.pageSize.getHeight() - 5);
        }
    }

    createPaymentForm() {
        this.paymentForm = this.fb.group({
            paymentMethod: new FormControl('', [Validators.required])
        });
    }

    hasError = (controlName: string, errorName: string) => {
        return ((this.submitted || this.paymentForm.controls[controlName].touched) && this.paymentForm.controls[controlName].hasError(errorName));
    }

    hide() {
        this.showPaymentDetails = false;
    }

    paymentConfirm() {
        this.submitted = true;
        if (!this.paymentForm.valid)
            return;
        let data = this.paymentData;
        console.log(this.paymentForm.value.paymentMethod);
        if (this.paymentForm.value.paymentMethod && this.paymentForm.value.paymentMethod != '') {
            switch (this.paymentForm.value.paymentMethod) {
                case 'nagad':
                    data['paymentType'] = 'nagad';
                    this.nagadPayment(data);
                    break;
                case 'bKash':
                    this.srcUrl = `${b2b_url}/paymentGateway/${this.confirmedData['BookingAppReference']}`
                    window.location.replace(this.srcUrl);
                    break;
                case 'sslCommerz':
                    data['paymentType'] = 'sslCommerz';
                    this.sslCommerzPayment(data);
                    break;

                default:
                    break;
            }
        }
    }

    submitTicket(data) {
        this.router.navigate(['/flight/payment-details'], {
            queryParams: {
                AppReference: data.AppReference,
            }
        });
    }

    intitiatePayment(){
        let date = (new Date().getTime()).toString();
        const userId = this.util.readStorage('b2cUser', sessionStorage)['id']
        const order_id = `IR${date.substring(10)}${date.substring(0, 7)}${date.substring(7)}`;
        let payload = {
            app_reference: this.confirmedData['AppReference'],
            order_id: order_id,
            payment_type: "Stripe",
            merchantInvoiceNumber: "Inv002",
            source: "flight",
            userId: userId ? userId : 0,
        }
        localStorage.setItem('orderId',order_id);
        this.subSunk.sink = this.apiHandlerService.apiHandler('transactionInit', 'post', '', '', payload).subscribe(res => {
            if (res) {
                this.paymentData = res.data;
                const redirectUrl = this.paymentData.url;
                window.location.href = redirectUrl;
            }
        });
    }

    walletPayment(data) {
        this.subSunk.sink = this.apiHandlerService.apiHandler('checkWalletBalance', 'post', '', '', { app_reference: data.BookingAppReference })
            .subscribe(res => {
                if (res && res.data[0].ticketFare) {
                    if (res.data[0].ticketFare > res.data[0].userWalletBalance) {
                        this.swalService.alert.oops("Your wallet balence is low.")
                    } else {
                        this.subSunk.sink = this.apiHandlerService.apiHandler('deductFromWallet', 'post', '', '', { app_reference: data.BookingAppReference })
                            .subscribe(res => {
                                if (res) {
                                    this.swalService.alert.success("Your transaction successful.")
                                    this.callPnrTicket(data);
                                }
                            }, (err => {
                                this.swalService.alert.oops(err.error.Message)
                                this.showPaymentDetails = false;
                            }));
                    }

                }
            }, (err => {
                this.swalService.alert.oops(err.error.Message)
                this.showPaymentDetails = false;
            }));
    }

    nagadPayment(data) {
        let date = (new Date().getTime()).toString();
       let invoiceNumber= this.flightService.setInvoiceNumber(data.BookingAppReference);
        this.subSunk.sink = this.apiHandlerService.apiHandler('executePayment', 'post', {}, {}, {
            app_reference: data.BookingAppReference,
            order_id: `FBPI${date.substr(10)}${date.substr(0, 7)}${date.substr(7)}`,
            payment_type: data.paymentType,
            merchantInvoiceNumber: invoiceNumber
        }).subscribe(resp => {
            if (resp.statusCode == 201 || resp.statusCode == 200) {
                window.location = resp.data.callBackUrl
            }
        })
    }

    callPnrTicket(data) {
        let TicketData = {
            AppReference: data.BookingAppReference,
            booking_source: data.booking_source,
            payment_type:'wallet'
            
        }
        this.subSunk.sink = this.apiHandlerService.apiHandler('pnrRetrieve', 'post', '', '', TicketData).subscribe(res => {
            if (res) {
                this.confirmedData = res.data.FinalBooking.BookingDetails;
                this.util.writeStorage("ticketCache", res.data.FinalBooking.BookingDetails, sessionStorage)
                this.showConfirmTicket = false;
            }
        });
    }

    sslCommerzPayment(data) {
        let date = (new Date().getTime()).toString();
        this.subSunk.sink = this.apiHandlerService.apiHandler('sslTransactionInit', 'post', {}, {}, {
            app_reference: data.BookingAppReference,
            order_id: `FBPI${date.substr(10)}${date.substr(0, 7)}${date.substr(7)}`,
            payment_type: data.paymentType
        }).subscribe(resp => {
            if (resp.statusCode == 201 || resp.statusCode == 200) {
                window.location = resp.data.ssl
            }
        })
    }

}